import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// On every open: (1) remove any old service worker + caches, then (2) detect a stale app
// shell by comparing the main JS bundle THIS page loaded against the one the server's current
// index.html references. If they differ, the user is on an out-of-date build (edge/browser
// cache) — reload ONCE (guarded by sessionStorage so it can never loop) to pull the latest.
(async () => {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) { /* ignore */ }
  try {
    if (typeof caches !== "undefined" && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (e) { /* ignore */ }

  try {
    const loaded = Array.from(document.querySelectorAll("script[src]"))
      .map((s) => s.getAttribute("src") || "")
      .find((src) => /\/static\/js\/main\.[\w-]+\.js/.test(src));
    if (!loaded) return; // dev build has no content-hashed bundle — nothing to compare
    const res = await fetch(`/index.html?_=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return;
    const html = await res.text();
    const m = html.match(/\/static\/js\/main\.[\w-]+\.js/);
    if (!m) return;
    const latest = m[0];
    if (loaded.indexOf(latest) !== -1) { sessionStorage.removeItem("rp_stale_reload"); return; }
    if (sessionStorage.getItem("rp_stale_reload")) return; // already reloaded this session
    sessionStorage.setItem("rp_stale_reload", "1");
    window.location.reload();
  } catch (e) { /* ignore */ }
})();
